import { ColumnImporterSettings } from '@components/trace/column/column.importer.settings';
import { Separator } from '@components/ui/separator';

import type { AtomModel } from '@models/atom.model';

import type { TableImporterDateColumnData } from '@stratumn/studio-shared';
import { DateWidgetSettings } from '@widgets/date/date.widget.settings';

type Props = {
  atom: AtomModel<TableImporterDateColumnData>;
};

export const DateSettingsModal = ({ atom }: Props) => (
  <>
    <DateWidgetSettings
      atomId={atom.id}
      deadlineWarningBuffer={atom.data.cell.view.deadlineWarningBuffer}
      doneVariableReference={atom.data.cell.view.doneVariableReference}
      isDeadline={atom.data.cell.view.isDeadline}
      onDeadlineWarningBufferChange={v =>
        (atom.data.cell.view.deadlineWarningBuffer = v)
      }
      onDoneVariableReferenceChange={v =>
        (atom.data.cell.view.doneVariableReference = v)
      }
      onIsDeadlineChange={v => (atom.data.cell.view.isDeadline = v)}
    />
    <Separator />
    <ColumnImporterSettings
      columnName={atom.data.title}
      from={atom.data.importerOptions.from}
      onFromChange={v => (atom.data.importerOptions.from = v)}
    />
    <Separator />
  </>
);
